import React, { useContext } from "react";

import constant from "lib/constant/constant";
import { Spinner } from "lib/components";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { OperatorManageVendor } from "./operator";

const { userKey } = constant;
const { operator } = userKey;

const AdvanceProviderList = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");

  const getComponent = (role) => {
    if (isLoading) {
      return <Spinner />;
    }
    if (role === operator) {
      return <OperatorManageVendor />;
    }
    return null;
  };

  const AdvanceProviderComponent = getComponent(currentUserRole);
  return AdvanceProviderComponent;
};

export default AdvanceProviderList;
